export default {
    data: () => ({
        currentDateSelectionKey: undefined,
    }),
    methods: {
        instantiateMewsDistributor (startDate, endDate) {
            /**
             * There's no way to destroy a Mews.Distributor instance
             * So this prevents multiple popups from appearing if the
             * user changes the dates.
             */
            this.currentDateSelectionKey = (
                JSON.stringify(startDate)
                + JSON.stringify(endDate)
                + JSON.stringify(new Date())
            ).replace(/[\W_]+/g, '')

            // eslint-disable-next-line no-undef
            Mews.Distributor(
                {
                    configurationIds: [
                        // eslint-disable-next-line no-undef
                        wpData.acf_fields.autoloaded_mews_id || '',
                    ],
                    openElements: `.distributor-open-${this.currentDateSelectionKey}`,
                },
                distributor => {
                    distributor.setStartDate(startDate);
                    distributor.setEndDate(endDate);
                }
            );
        },
    }
}
